export const tabsNav = {
    medicalServiceTypes: {
        id: 'medicalServiceTypes',
        name: 'Типы консультаций',
        template: 'medicalServiceTypes',
        pathName: 'medicalServiceTypes',
        icon: 'briefcase',
        iconSize: '15',
    },
    specializations: {
        id: 'specializations',
        name: 'Специализации',
        template: 'specializations',
        pathName: 'specializations',
        icon: 'briefcase',
        iconSize: '15',
    },
    symptoms: {
        id: 'symptoms',
        name: 'Симптомы',
        template: 'symptoms',
        pathName: 'symptoms',
        icon: 'briefcase',
        iconSize: '15',
    },
    cities: {
        id: 'cities',
        name: 'Города',
        template: 'cities',
        pathName: 'cities',
        icon: 'briefcase',
        iconSize: '15',
    },
    pages: {
        id: 'pages',
        name: 'Статические страницы',
        template: 'pages',
        pathName: 'pages',
        icon: 'briefcase',
        iconSize: '15',
    },
    files: {
        id: 'files',
        name: 'Файлы заключений',
        template: 'files',
        pathName: 'files',
        icon: 'briefcase',
        iconSize: '15',
    },
    // images: {
    //     id: 'images',
    //     name: 'Изображения',
    //     template: 'images',
    //     pathName: 'images',
    //     icon: 'briefcase',
    //     iconSize: '15',
    // },
    administrators: {
        id: 'administrators',
        name: 'Администраторы',
        template: 'administrators',
        pathName: 'administrators',
        icon: 'briefcase',
        iconSize: '15',
    },
    subscriptions: {
        id: 'subscriptions',
        name: 'Подписки',
        template: 'subscriptions',
        pathName: 'subscriptions',
        icon: 'briefcase',
        iconSize: '15',
    },
    cancellationReasons: {
        id: 'cancellationReasons',
        name: 'Причины отмены',
        template: 'cancellationReasons',
        pathName: 'cancellationReasons',
        icon: 'briefcase',
        iconSize: '15',
    },
    difficulties: {
        id: 'difficulties',
        name: 'Проблемы',
        template: 'difficulties',
        pathName: 'difficulties',
        icon: 'briefcase',
        iconSize: '15',
    }
};
